import React, { useEffect, useMemo, useState } from 'react'
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IKImage } from 'imagekitio-react';
import dateformat from 'dateformat';
import InfiniteScroll from 'react-infinite-scroller';
import RolodexEmptyMessage from "src/legacy/images/homeEmptyMessage.svg";
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import BackButton from "src/legacy/components/BackButton";
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import { fetchAllWorkspaces, fetchStoryboards, activateWorkspace, fetchActivatedWorkspaces } from 'src/legacy/redux/actions/integrations/cleverstory';
import { deleteDataSource } from 'src/redux/actions/dataSource.ts';
import { fetchActivatedWorkSpaces as fetchActivations } from 'src/redux/actions/cleverstory'; 
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import CleverstoryLogo from 'src/legacy/images/cleverstory.png'
import StoryboardImage from 'src/legacy/images/storyboard.png'
import { localizedStrings } from 'src/localization/index.jsx';
import IntegrationsService from 'src/legacy/services/integrations.service';
import _ from 'lodash';
import cx from 'classnames';
import styles from './styles.module.scss';
import Button from 'src/components/button';
import Truncate from 'src/components/truncate';
import { useNavigate } from 'react-router-dom';

export default function CleverstoryIntegration() {

  const dispatch = useDispatch();

  const allWorkSpaces = useSelector((state) => _.get(state.legacyRootReducer, "settings.integrations.cleverstory.allWorkspaces", []));
  const activatedWorkspaces = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.activatedWorkspaces`, {}));

  useEffect(() => {
    if (_.size(activatedWorkspaces.items) === 0) {
      dispatch(fetchActivatedWorkspaces());
    }

    if (_.size(allWorkSpaces.items) === 0) {
      dispatch(fetchAllWorkspaces());
    }

  }, [])

  return (
    <Row className={styles.outerContainer}>
      <Col md={3} className={styles.sideBarContainer}>
        <SideBar />
      </Col>
      <Col md={9} className={styles.detailViewContainer}>
        <DetailView />
      </Col>
    </Row>
  )
}

function SideBar() {

  const navigate = useNavigate();
  const localizedCommons = _.get(localizedStrings, 'commons');
  const localizedCleverstoryContents = _.get(localizedStrings, 'components.integrations.cleverstory');

  return (
    <div>
      <BackButton
        className={styles.backButton}
        title={_.get(localizedCommons, "actions.back", "")}
        onClick={() => {
          navigate("/settings/integrations");
        }}
      />

      <div className={styles.contentContainer}>
        <img src={CleverstoryLogo} className={styles.logo} />
        <div className={styles.content}>
          {_.get(localizedCleverstoryContents, "sub_text", "")}
        </div>
      </div>

    </div>
  )
}

function DetailView() {

  const allWorkSpaces = useSelector((state) => _.get(state.legacyRootReducer, "settings.integrations.cleverstory.allWorkspaces", []));

  const allWorkSpacesRecords = _.get(allWorkSpaces, "items", []);
  const isFetchingAllWorkSpaces = _.get(allWorkSpaces, "loading", false);

  const localizedCommons = _.get(localizedStrings, 'commons');
  const localizedCleverstoryContents = _.get(localizedStrings, 'components.integrations.cleverstory');
  const localizedHub = _.get(localizedStrings, "pages.hub");
  const localizedErrors = _.get(localizedHub, "error_messages");

  if (isFetchingAllWorkSpaces) {
    return <p className={styles.messageContainer}> {_.get(localizedCommons, "loading.loading")}... </p>
  }

  return (
    <div className={styles.innerContainer}>
      <p className={styles.header}>{_.get(localizedCleverstoryContents, "header", "")}</p>

      <div className={styles.workspaceContainer}>

        {_.size(allWorkSpacesRecords) === 0 && <p className={styles.messageContainer}>

          <PlaceholderEmptyMessage
            title={localizedCleverstoryContents.access.title}
            message={localizedCleverstoryContents.access.description}
            image={RolodexEmptyMessage}
            className={styles.emptyHubsIcon}
            visible={true}
          />

        </p>}

        {_.size(allWorkSpacesRecords) > 0 && (
          <div>
            {_.map(allWorkSpacesRecords, (workspace) => (
              <Workspace workspace={workspace} />
            ))}
          </div>
        )}
      </div>

    </div>
  )

}

function Workspace(props) {

  const dispatch = useDispatch();

  const workspace = _.get(props, "workspace", {});
  const workspaceId = _.get(workspace, "id", "");

  const user = useSelector((state) => _.get(state, "users.me", {}));

  const activatedWorkspaces = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.activatedWorkspaces`, {}));
  const storyboards = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.storyboards[${workspaceId}]`, {}));
  const workspaceActivation = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.workspace[${workspaceId}]`, {}));
  const isDeactivatingWorkspace = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.deactivatingWorkspace.deactivating`, false));
  const workspaceDeaActivated = useSelector((state) => _.get(state.legacyRootReducer, `settings.integrations.cleverstory.deactivatingWorkspace.deactivated`, false));

  useEffect(() => {
    if(workspaceDeaActivated){
        dispatch(fetchActivatedWorkspaces());
        dispatch(fetchActivations());
        setShowSlider(false);
    }
  }, [workspaceDeaActivated])
  
  const [showSlider, setShowSlider] = useState(false);
  const [renderStoryboards, setRenderStoryboards] = useState(false);

  const activatedWorkspacesItems = _.get(activatedWorkspaces, "items");
  const activeWorkspaceData = _.find(activatedWorkspacesItems, { workspace: workspaceId });

  var activatedWorkspacesIds = [];
  if (_.size(activatedWorkspacesItems) > 0) {
    activatedWorkspacesIds = _.map(activatedWorkspacesItems, (item) => item.workspace);
  }
  const isWorkspaceActivated = _.includes(activatedWorkspacesIds, workspaceId);

  const currentPage = _.get(storyboards, "currentPage");
  const totalPages = _.get(storyboards, "totalPages");
  const storyboardRecords = _.get(storyboards, "items", []);
  const isStoryboardsLoading = _.get(storyboards, "loading", false);
  const isWorkSpaceActivating = _.get(workspaceActivation, "activating", false);
  const isActivatedWorkspacesFetching = _.get(activatedWorkspaces, "loading", false);

  const localizedCleverstoryContents = _.get(localizedStrings, 'components.integrations.cleverstory');
  const localizedCommons = _.get(localizedStrings, 'commons');
  const localizedIntegrationActions = _.get(localizedStrings, 'components.integrations.actions');

  const handleWorkspaceClick = () => {

    if (isStoryboardsLoading || showSlider) {
      return;
    }

    if (renderStoryboards) {
      setRenderStoryboards(false);
      return;
    }

    if (_.size(storyboardRecords) === 0) {
      dispatch(fetchStoryboards(workspaceId, {}));
    }

    setRenderStoryboards(true);

  }

  const loadMore = () => {

    const nextPage = currentPage + 1;

    if (isStoryboardsLoading || nextPage >= totalPages) {
      return;
    }

    dispatch(fetchStoryboards(workspaceId, { page: nextPage }));

  }

  const handleWorkSpaceActivate = (e) => {
    e.stopPropagation()
    if (showSlider) {
      return;
    }
    setShowSlider(true);
  }

  const handleClickAction = () => {
    if (isWorkspaceActivated) {
      dispatch(deleteDataSource({id:_.get(activeWorkspaceData, "id")}))
    }
    else {
      dispatch(activateWorkspace(workspaceId, workspace.name)).then(() => {
        dispatch(fetchActivatedWorkspaces());
        dispatch(fetchActivations());
        setShowSlider(false);
        dispatch(trackAdoptionMetricsForPluginConnectedEvent("Cleverstory"))
      })
    }
  }

  const getTitle = () => {
    if (isWorkspaceActivated) {
      if (isDeactivatingWorkspace) {
        return localizedIntegrationActions.deactivating
      }
      return localizedIntegrationActions.deactivate
    }
    else {
      if (isWorkSpaceActivating) {
        return localizedIntegrationActions.activating
      }
      return localizedIntegrationActions.activate
    }
  }

  return (
    <div onClick={handleWorkspaceClick} className={cx(styles.workspace, {
      [styles.noBorder]: props.noBorder
    })}>

      <p>
        <span className={styles.name}> {_.get(workspace, "name")}

          <i className={cx(styles.dropdownIcon,"paperflite-dropdown", {
            [styles.rotateIcon]: renderStoryboards
          })} />

        </span>
      </p>

      <p className={styles.metadata}>
        <span className={styles.count}> {_.get(workspace, "storyBoardCount")} {_.get(localizedCleverstoryContents, "storyboards", "")} </span>
      </p>

      <button className={cx(styles.activateButton, {
        [styles.disabledColor]: isWorkspaceActivated || !user.admin
      })} disabled={isActivatedWorkspacesFetching || !user.admin} onClick={handleWorkSpaceActivate}> {isWorkspaceActivated ? localizedIntegrationActions.deactivate : localizedIntegrationActions.activate}</button>

      {renderStoryboards && _.size(storyboardRecords) > 0 && <div className={styles.storyboardsContainer}>
        <InfiniteScroll
          pageStart={0}
          initialLoad={false}
          hasMore={true}
          loadMore={(page) => { loadMore() }}
          useWindow={false}
          threshold={250}
        >
          {_.map(storyboardRecords, (storyboard) => (
            <Storyboard storyboard={storyboard} />
          ))}
        </InfiniteScroll>

      </div>}

      {isStoryboardsLoading && renderStoryboards && <p className={styles.loadingMessage}> {_.get(localizedCommons, "loading.loading")}... </p>}

      {!isStoryboardsLoading && renderStoryboards && _.size(storyboardRecords) === 0 && <p className={styles.messageContainer}> {localizedCleverstoryContents.no_storyboards} </p>}

      <SlidePaneView show={showSlider} width="30vw">
        <div className={styles.sliderContainer}>
          <div className={styles.contentContainer}>
            <div>
              {isWorkspaceActivated && <div>
                <p className={styles.title}> {localizedIntegrationActions.deactivating}</p>
                <p className={styles.subText}> {localizedStrings.formatString(localizedCleverstoryContents.deactivate.description, {
                  name: _.get(activeWorkspaceData, "workspaceName"),
                  assetsCount: _.get(activeWorkspaceData, "assets", 0)
                })} </p>
              </div>}
              {!isWorkspaceActivated && <div>
                <p className={styles.title}>  {localizedIntegrationActions.activating}</p>
                <p className={styles.subText}> {localizedStrings.formatString(localizedCleverstoryContents.activate.description, {
                  name: _.get(workspace, "name")
                })} </p>
              </div>}

              <div className={styles.silderButtonContainer}>
                  <Button
                    text={getTitle()}
                    variant='primary'
                    disabled={isWorkSpaceActivating || isDeactivatingWorkspace}
                    onClick={handleClickAction}
                  />

                  <Button
                    text={localizedCommons.actions.cancel}
                    onClick={() => setShowSlider(false)} />

              </div>
            </div>
          </div>
        </div>
      </SlidePaneView>

    </div>
  )
}

function Storyboard(props) {

  const storyboard = _.get(props, "storyboard", {});
  const localizedCommons = _.get(localizedStrings, 'commons');
  const icon = _.get(storyboard, "page.icon.url");

  const storyBoardType = useMemo(() => {
    return IntegrationsService.getStoryBoardType(_.get(storyboard, "page.storyboardType", ""));
  }, [storyboard]);

  return (
    <div className={styles.storyboardContainer} onClick={(e) => e.stopPropagation()}>

      {!icon ? <img src={StoryboardImage} className={styles.storyboardImage} /> : <IKImage
        className={styles.storyboardImage}
        path={icon}
      />}
      <div className={styles.content}>
        <Truncate width={200} lines={1}> {_.get(storyboard, "name", "")} </Truncate>
        <div className={styles.metadata}>
          <p>{storyBoardType}</p>
          <p>{_.get(localizedCommons, "last_updated", "")}: {dateformat(_.get(storyboard, "modifiedDate"), 'dd mmm yyyy')} </p>
        </div>
      </div>
    </div>
  )
}
